import { createSelector } from '@reduxjs/toolkit';
import { parseISO } from 'date-fns';

import { createOrderBill, createSubscriptionBill } from '_helpers/billing';
import { selectOrderList, selectData as selectOrdersData } from '_store/orders/selector';

export const selectPaymentMethodsData = (state) => state.billing.paymentMethods.data;
export const selectPaymentMethodsError = (state) => state.billing.paymentMethods.error;
export const selectPaymentMethodsLoading = (state) => state.billing.paymentMethods.loading;
export const selectPaymentMethodsCreating = (state) => state.billing.paymentMethods.creating;

export const selectSubscriptionsData = (state) => state.billing.subscriptions.data;
export const selectSubscriptionsError = (state) => state.billing.subscriptions.error;
export const selectSubscriptionsLoading = (state) => state.billing.subscriptions.loading;
export const selectSubscriptionsCanceling = (state) => state.billing.subscriptions.canceling;

export const selectSubscriptionsDetailsData = (state) => state.billing.subscriptionsDetails.data;
export const selectSubscriptionsDetailsError = (state) => state.billing.subscriptionsDetails.error;
export const selectSubscriptionsDetailsLoading = (state) => state.billing.subscriptionsDetails.loading;

export const selectBillList = createSelector(
  [selectOrdersData, selectSubscriptionsDetailsData],
  (orders, subscriptions) => {
    const subscriptionBills = (subscriptions || []).flatMap((sub) =>
      (sub?.bills || []).map((bill) => createSubscriptionBill(sub, bill))
    );

    const orderBills = (orders || []).map(createOrderBill).filter(Boolean);

    const additionalBills = orderBills?.reduce((res, item) => {
      if (!subscriptionBills?.map(({ orderId }) => orderId)?.includes(item?.orderId)) {
        res.push(item);
      }
      return res;
    }, []);

    return [...subscriptionBills, ...additionalBills].sort((a, b) => parseISO(b.orderDate) - parseISO(a.orderDate));
  }
);

export const selectSubscriptionsList = createSelector(
  [selectOrderList, selectSubscriptionsData],
  (orderList, subscriptions) => {
    return subscriptions
      ?.reduce((res, item) => {
        const order = orderList?.find(({ crmOrderId }) => crmOrderId === item?.orderId);

        if (order) {
          const { orderDate, processingOption } = order;
          res.push({ ...item, orderDate, processingOption });
        }

        return res;
      }, [])
      .sort((a, b) => parseISO(b.nextPayDate) - parseISO(a.nextPayDate));
  }
);
